import styled from "styled-components";
import { darken, transparentize } from "polished";

export const Container = styled.form`
  padding: 48px 48px 33px;

  div {
    width: 100%;
  }

  textarea {
    width: 100%;
    font-size: 1rem;
  }

  .react-modal-form-radio {
    width: 100%;

    display: flex;
    flex-direction: column;
    height: 69px;

    label {
      margin: 0;
      font-weight: 700;
      color: #495156;
      font-size: 1rem;
    }

    div {
      display: flex;
      align-items: center;
      margin: 0;

      label {
        margin: 0;
        margin-right: 20px;
      }

      input[type="radio"] {
        padding: 0.5rem;
        height: 4rem;
      }
    }

    .radio-container {
      justify-content: start;
      height: 20px;
    }
  }

  button {
    width: 153px;
    height: 45px;
  }

  .cancelar {
    background-color: #43474a;
  }
`;

export const Conten = styled.div`
  margin: 0;

  .modal-header {
    background-color: #94E8E8;
    border-radius: 24px 24px 0 0;
    padding: 0;
    height: 90px;
  }

  .header-container {
    margin: 27px 10px 27px 49px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .modal-header .close {
    margin: 27px;
  }

  .modal-body {
    padding: 0;
  }

  .modal-footer {
    padding: 0;
    border-top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const ModalContainer = styled.div`
  .modal-content {
    height: 355px;
    width: 620px;
    border: 0;
    max-width: 620px;
  }
`;

export const ModalTitle = styled.span`
  color: #43474a;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
`;
